import script from "./sf-assistant-check.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-assistant-check.vue?vue&type=script&setup=true&lang=ts"

import "./sf-assistant-check.vue?vue&type=style&index=0&id=002bb217&lang=scss"

const __exports__ = script;

export default __exports__